import React from "react"

const logRender = (
  id,
  phase,
  actualDuration,
  baseDuration,
  startTime,
  commitTime
) => {
  if (typeof window === "undefined" || process.env.NODE_ENV !== "development") {
    return
  }

  console.debug("[React Profiler]", {
    id,
    phase,
    actualDuration: Number(actualDuration.toFixed(2)),
    baseDuration: Number(baseDuration.toFixed(2)),
    startTime: Number(startTime.toFixed(2)),
    commitTime: Number(commitTime.toFixed(2)),
  })
}

export const wrapWithRenderProfiler = (element) => {
  if (process.env.NODE_ENV !== "development") return element

  return React.createElement(
    React.Profiler,
    { id: "GatsbyRoot", onRender: logRender },
    element
  )
}
